import { ReceivingTab } from './receiving.tab';
import { TransferringTab } from './transferring.tab';
import { InboxTab } from './inbox.tab';
import { KWHTab, KWSTab, DWSTab } from './product.tab';

export { ReceivingTab, TransferringTab, InboxTab, KWHTab, KWSTab, DWSTab };
